import { useState } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SUBMISSION_API_BASE_URL;

export default function useSubmissionApi() {
    const [submissionLoading, setLoading] = useState(false);
    const [submissionError, setError] = useState(null);

    const submissionExecute = async () => {
        setLoading(true);
        setError(undefined);

        try {
            const request = await axios.post(`${BASE_URL}/submissions/active/uploads`, {}, {
                timeout: 120000
            });
            console.log(request.data.uploadFilePath);
            return request.data.uploadFilePath;
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        submissionLoading,
        submissionError,
        submissionExecute,
    };
}
